import React from "react";

const STATUS_OPTIONS = [
    { value: null, label: "Toutes" },
    { value: "A_VALIDER", label: "À valider" },
    { value: "VALIDE", label: "Validées" },
];

const READ_OPTIONS = [
    { value: null, label: "Tous" },
    { value: false, label: "Non lus" },
    { value: true, label: "Lus" },
];

const FAVORITE_OPTIONS = [
    { value: null, label: "Tous" },
    { value: true, label: "Favoris" },
    { value: false, label: "Non favoris" },
];

function SegmentedFilter({ label, options, value, onChange }) {
    return (
        <div className="commande-filter-group">
            <span className="commande-filter-label">{label}</span>
            <div className="commande-filter-segments" role="group" aria-label={label}>
                {options.map(option => (
                    <button
                        key={String(option.value)}
                        type="button"
                        aria-pressed={value === option.value}
                        className={`commande-filter-segment${value === option.value ? " is-active" : ""}`}
                        onClick={() => onChange(option.value)}
                    >
                        {option.value === true && label === "Favoris" && <span aria-hidden="true">★</span>}
                        {option.value === false && label === "Favoris" && <span aria-hidden="true">☆</span>}
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default function FiltersSideBar({
    selectedStatuts = [],
    setSelectedStatuts,
    patientSearch = "",
    setPatientSearch,
    readFilter = null,
    setReadFilter,
    favoriteFilter = null,
    setFavoriteFilter,
    setPage,
    showStatutFilter = false,
    section = "all",
}) {
    const statusValue = selectedStatuts.length === 1 ? selectedStatuts[0] : null;
    const update = (setter, value) => {
        setter(value);
        setPage(0);
    };

    const search = (
        <div className="commande-filter-search">
            <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                <circle cx="11" cy="11" r="7" />
                <line x1="16.2" y1="16.2" x2="21" y2="21" />
            </svg>
            <input
                type="search"
                aria-label="Rechercher dans les commandes"
                placeholder="Patient, classification, produit, EHPAD ou date…"
                value={patientSearch}
                onChange={event => update(setPatientSearch, event.target.value)}
            />
            {patientSearch && (
                <button
                    type="button"
                    className="commande-filter-clear"
                    aria-label="Effacer la recherche"
                    onClick={() => update(setPatientSearch, "")}
                >
                    ×
                </button>
            )}
        </div>
    );

    const options = (
        <div className="commande-filter-options">
            {showStatutFilter && (
                <SegmentedFilter
                    label="Statut"
                    options={STATUS_OPTIONS}
                    value={statusValue}
                    onChange={value => update(setSelectedStatuts, value ? [value] : [])}
                />
            )}
            <SegmentedFilter
                label="Lecture"
                options={READ_OPTIONS}
                value={readFilter}
                onChange={value => update(setReadFilter, value)}
            />
            <SegmentedFilter
                label="Favoris"
                options={FAVORITE_OPTIONS}
                value={favoriteFilter}
                onChange={value => update(setFavoriteFilter, value)}
            />
        </div>
    );

    if (section === "search") return search;
    if (section === "filters") return options;
    return <div className="commande-filter-bar">{search}{options}</div>;
}
